import './App.css';
import {
  Box,
  ChakraProvider,
  Divider,
  extendTheme,
  Text,
} from '@chakra-ui/react';
import Home from './components/Home';
import useScreen from './hooks/useScreen';
import '@fontsource/pinyon-script';
import '@fontsource/inter';
import '@fontsource/lustria';
import './styles/fonts.css';

import newBg from './images/header-web.jpg';
import newBgMobile from './images/header-mobile.jpg';

import { motion } from 'framer-motion';
import WeddingDetails from './components/WeddingDetails';
import SnapAndShare from './components/SnapAndShare';
import GuestInformation from './components/GuestInformation';

const theme = extendTheme({
  colors: {
    copper: {
      100: '#bf8b7f',
      200: '#b7766e',
      300: '#bf807f',
      400: '#ab7f66',
      500: '#BD8A7E',
      600: '#6A4D4C',
    },
    floral: {
      100: '#fbf8f4',
    },
    cultured: {
      100: '#f5f5f0',
    },
  },
  fonts: {
    // heading: "'Times New Roman', Times, serif",
    heading: 'Lustria',
    body: 'Lustria',
  },
});

export default function App() {
  const { isMobile } = useScreen();

  return (
    <ChakraProvider theme={theme}>
      <div className="App">
        <Box bgColor="#313e60" w="100vw" height="100vh" overflow="scroll">
          <Box
            pos={'relative'}
            bgImage={isMobile ? newBgMobile : newBg}
            bgRepeat={'no-repeat'}
            bgSize={'cover'}
            width="full"
            height="full"
            bgPos={'center'}
            padding="24px"
          >
            <Box
              className="fluidOverlay"
              position="absolute"
              top="0"
              left="0"
              width="100%"
              height="100%"
              bgColor="#1f2535"
              mixBlendMode={'multiply'}
              opacity="0.5"
            ></Box>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1, ease: 'easeInOut' }}
            >
              <Home id="home" height="100vh" pb="100px" />
            </motion.div>
          </Box>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: 'easeInOut' }}
          >
            <WeddingDetails />
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: 'easeInOut' }}
          >
            <GuestInformation />
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: 'easeInOut' }}
          >
            <SnapAndShare />
          </motion.div>

          <Divider />
        </Box>
      </div>
    </ChakraProvider>
  );
}
